import { useMemo } from 'react'

import useRoomConfigData from '@utilities/useRoomConfigData'

interface UseEnableCarouselKeyboardControlProps {
  isSessionConnected: boolean
  toggleControls?: boolean
  playerState?: boolean
}

const useEnableCarouselKeyboardControl = ({
  isSessionConnected,
  toggleControls = false,
  playerState = false,
}: UseEnableCarouselKeyboardControlProps) => {
  const { roomConfigData } = useRoomConfigData()

  return useMemo(() => {
    const baseKeyboardControl = isSessionConnected
      ? roomConfigData?.slideShow?.allowKeyboardToControlSlideShow
      : !toggleControls

    return Boolean(!playerState && baseKeyboardControl)
  }, [
    isSessionConnected,
    playerState,
    toggleControls,
    roomConfigData?.slideShow?.allowKeyboardToControlSlideShow,
  ])
}

export default useEnableCarouselKeyboardControl
